import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataBagService } from '@/common/data-bag.service';
import { Nationality, UserData } from '@/reservation/reservation.model';

@Injectable({
	providedIn: 'root',
})
export class BagPaymentListService {
	nationalities: Nationality[] = [];
	users: Subject<UserData[]> = new Subject();
	payment$: Subject<any[]> = new Subject();
	filtersParms;

	constructor(private readonly api: DataBagService) {}

	loadPayments(parms?) {
		if (parms) this.filtersParms = parms;
		this.api.get(`/reservation/payment/?${this.filtersParms}`, (result, error) => {
			if (result.results) this.payment$.next(result);
		});
	}

	loadUsers(callback) {
		this.api.get('/profile/data_full/?limit=99999', ({ results }) => {
			if (results) this.users.next(results);
			callback();
		});
	}
}
